<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    @if (data === '') {
    <h4>Save Comparison</h4>
    } @if (data !== '') {
    <h4>Update Comparison</h4>
    }

    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onCancelClick()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content [formGroup]="myGroup">
    <mat-form-field class="full-width" mat-focused>
      <mat-label>Comparison Name: </mat-label>
      <input
        matInput
        formControlName="rankingNameFormControl"
        cdkFocusInitial
        id="cpName"
        value="{{data}}"
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <div>
      <button
        mat-button
        (click)="onCancelClick()"
        class="button-close"
        cdkFocusInitial
      >
        Cancel
      </button>

      <button
        mat-button
        (click)="onSaveComparison()"
        class="button-close"
        [disabled]="!myGroup.valid"
        cdkFocusInitial
      >
        Save
      </button>
    </div>
  </div>
</div>
